<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <g clip-path="url(#clip0_3491_584)">
      <path
        d="M19.3334 14.6666H14.6667C14.3131 14.6666 13.9739 14.8071 13.7239 15.0572C13.4738 15.3072 13.3334 15.6463 13.3334 16V25.3333C13.3334 25.6869 13.4738 26.0261 13.7239 26.2761C13.9739 26.5262 14.3131 26.6666 14.6667 26.6666H24C24.3537 26.6666 24.6928 26.5262 24.9428 26.2761C25.1929 26.0261 25.3334 25.6869 25.3334 25.3333V20.6666"
        stroke="#040325"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.3334 13.6667C24.5986 13.4014 24.9583 13.2524 25.3334 13.2524C25.7084 13.2524 26.0682 13.4014 26.3334 13.6667C26.5986 13.9319 26.7476 14.2916 26.7476 14.6667C26.7476 15.0417 26.5986 15.4014 26.3334 15.6667L20 22L17.3334 22.6667L18 20L24.3334 13.6667Z"
        stroke="#040325"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3491_584">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
